<template>
  <div v-if="nodeList.length > 0" class="mLocat">
    <div class="mLocat-wrap">
      <template v-for="(item, i) in nodeList">
        <a v-if="i < nodeList.length - 1" @click="handleClick(item)" href="javascript:" class="mLocat-link">{{ item.name }}</a>
        <span v-if="i < nodeList.length - 1" class="mLocat-text"> &gt; </span>
        <span v-if="i === nodeList.length - 1" class="mLocat-text">{{ item.name }}</span>
      </template>
    </div>
  </div>
</template>
<script>
  import util from '../../libs/util'
  export default {
    name: 'crumbs-nav',
    computed: {
      nodeList() {
        let nodeList = []
        let menu = this.$route.meta.menu
        if (menu && menu.showInLeftMenu === '0') {
          nodeList.push(menu)
          while (menu.parent) {
            nodeList.push(menu.parent)
            menu = menu.parent
          }
        }
        nodeList.reverse()
        return nodeList
      }
    },
    methods: {
      handleClick(node) {
        let routerName = node.routerName || node.id
        util.routerBack(this, routerName)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/crumbs-nav/crumbs-nav.vue